<template>
  <div class="portfolios-sidebar-tab">
    <div class="title">
      <horizontal-title-tooltip-section
        :title="$t('portfolioManager.portfoliosSidebar.title')"
        size="l"
        spacing="left"
      />
    </div>
    <div v-if="portfoliosLoad" class="spinner-holder">
      <b-spinner class="spinner" />
    </div>
    <div
      class="saved-portfolios slim-scroll"
      v-else-if="savedPortfolios.length"
    >
      <saved-portfolio-item
        v-for="item in savedPortfolios"
        :key="item.portfolio_id"
        :name="item.portfolio_name"
        :date="item.last_history_obj.date"
        :id="item.portfolio_id"
        :idVersion="item.last_history_obj.history_id"
        :active="
          portfolio &&
          portfolio.portfolio_id &&
          item.portfolio_id &&
          item.portfolio_id.toString() === portfolio.portfolio_id.toString()
        "
      />
    </div>
    <div v-else>
      <span class="info">{{
        $t("portfolioManager.portfoliosSidebar.noSavedPortfolios")
      }}</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import HorizontalTitleTooltipSection from "./inputs/HorizontalTitleTooltipSection.vue";
import SavedPortfolioItem from "./SavedPortfolioItem.vue";
export default {
  name: "portfolios-sidebar-tab",
  components: {
    HorizontalTitleTooltipSection,
    SavedPortfolioItem,
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions("portfolioManagerStore", ["getSavedPortfolios"]),
  },
  computed: {
    ...mapGetters("portfolioManagerStore", [
      "savedPortfolios",
      "newImportedPortfolios",
      "portfoliosLoad",
      "portfolio",
    ]),
  },
  mounted() {
    this.getSavedPortfolios();
  },
  watch: {
    newImportedPortfolios(newVal, oldVal) {
      if (newVal.length > oldVal.length) {
        this.getSavedPortfolios();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.portfolios-sidebar-tab {
}
.spinner-holder {
  padding: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.saved-portfolios {
  overflow-y: auto;
  max-height: calc(100vh - 161px);
  margin-left: -8px;
  margin-right: -8px;
  padding-bottom: 5rem;
}
</style>